import { RootState } from '@/store/store'
import { createSelector } from '@reduxjs/toolkit'

/**
 * Selector: Last Viewed Conversation ID By Matter
 * Returns the last viewed conversation ID for the given matter.
 * Returns null if no matter is selected.
 */
export const selectLastViewedConversationId = createSelector(
  (state: RootState) => state.conversationNavigationState.lastViewedByMatter,
  (_: RootState, props: { matterId: string | null }) => props.matterId,
  (lastViewedByMatter, matterId) => (matterId ? lastViewedByMatter[matterId] ?? null : null)
)
